module.exports = __webpack_public_path__ + "static/media/announcements.d99d9715.svg";